export const ROLES = {
    Student: 'Student',
    Teacher: 'Teacher', 
    Admin: 'Admin'
}